import { render, staticRenderFns } from "./biz-intro.vue?vue&type=template&id=50923401&scoped=true&lang=pug&"
import script from "./biz-intro.vue?vue&type=script&lang=js&"
export * from "./biz-intro.vue?vue&type=script&lang=js&"
import style0 from "./biz-intro.vue?vue&type=style&index=0&id=50923401&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50923401",
  null
  
)

export default component.exports